export const COLLECTIONS = {
  "case-studies": {
    label: "Case Studies",
    titleField: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug", type: "text", hint: "Leave blank to auto-generate" },
      { name: "client", label: "Client", type: "text" },
      { name: "industry", label: "Industry", type: "text" },
      { name: "series_code", label: "Service series", type: "select", options: ["L", "M", "S", "D"] },
      { name: "company_size", label: "Company size", type: "select", options: ["1–50", "51–200", "201–500", "500+"] },
      { name: "cover_image", label: "Cover image", type: "image" },
      { name: "context", label: "Context", type: "rich" },
      { name: "problem", label: "Problem", type: "rich" },
      { name: "approach", label: "Approach", type: "rich" },
      { name: "outcome", label: "Outcome", type: "rich" },
      {
        name: "metrics",
        label: "Metric highlights",
        type: "repeat",
        subFields: [
          { name: "label", label: "Label", type: "text" },
          { name: "value", label: "Value (e.g. 2.4x)", type: "text" },
        ],
      },
      { name: "quote_text", label: "Pull quote", type: "textarea" },
      { name: "quote_author", label: "Quote author", type: "text" },
      { name: "featured", label: "Featured on home", type: "switch" },
      { name: "order", label: "Sort order", type: "number" },
      { name: "seo_title", label: "SEO title", type: "text" },
      { name: "seo_description", label: "SEO description", type: "textarea" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },
  services: {
    label: "Service Series",
    titleField: "title",
    fields: [
      { name: "series_code", label: "Series code (L / M / S / D)", type: "text" },
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug", type: "text", hint: "Leave blank to auto-generate" },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "method_line", label: "Frameworks line (shown under the overview)", type: "textarea" },
      { name: "description", label: "Description", type: "rich" },
      { name: "hero_image", label: "Hero image", type: "image" },
      {
        name: "programs",
        label: "Sub-programs",
        type: "repeat",
        subFields: [
          { name: "title", label: "Program title", type: "text" },
          { name: "description", label: "Description", type: "textarea" },
        ],
      },
      { name: "order", label: "Sort order", type: "number" },
      { name: "seo_title", label: "SEO title", type: "text" },
      { name: "seo_description", label: "SEO description", type: "textarea" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },
  posts: {
    label: "Blog Posts",
    titleField: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug", type: "text", hint: "Leave blank to auto-generate" },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "body", label: "Body", type: "rich" },
      { name: "cover_image", label: "Cover image", type: "image" },
      { name: "author", label: "Author", type: "text" },
      { name: "tags", label: "Tags (comma separated)", type: "text" },
      { name: "published_at", label: "Published at (ISO date, e.g. 2026-01-15)", type: "text" },
      { name: "seo_title", label: "SEO title", type: "text" },
      { name: "seo_description", label: "SEO description", type: "textarea" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },
  testimonials: {
    label: "Testimonials",
    titleField: "client",
    fields: [
      { name: "client", label: "Client / company", type: "text", required: true },
      { name: "role", label: "Role / attribution", type: "text" },
      { name: "quote", label: "Quote", type: "textarea", required: true },
      { name: "industry", label: "Industry", type: "text" },
      { name: "featured", label: "Show as main quote", type: "switch" },
      { name: "order", label: "Sort order", type: "number" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },
  team: {
    label: "Team Members",
    titleField: "name",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Role", type: "text" },
      { name: "photo", label: "Headshot", type: "image" },
      { name: "bio", label: "Bio", type: "textarea" },
      { name: "order", label: "Sort order", type: "number" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },
  media: {
    label: "Media Coverage",
    titleField: "headline",
    fields: [
      { name: "headline", label: "Headline", type: "text", required: true },
      { name: "publication", label: "Publication", type: "text", required: true },
      { name: "date_label", label: "Date (as printed)", type: "text", hint: "e.g. 3 December 2015" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "byline", label: "Byline / section", type: "text" },
      { name: "focus", label: "Coverage focus", type: "text" },
      { name: "clipping_image", label: "Clipping image", type: "image" },
      { name: "source_url", label: "Source URL (optional)", type: "text" },
      { name: "order", label: "Sort order", type: "number" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },
  clients: {
    label: "Client Logos",
    titleField: "name",
    fields: [
      { name: "name", label: "Company name", type: "text", required: true },
      { name: "group", label: "Section", type: "select", options: ["clients", "partnered", "ecosystem"], hint: "clients = home strip + About; partnered / ecosystem = About page only" },
      { name: "image", label: "Logo", type: "image" },
      { name: "website", label: "Website (optional)", type: "text" },
      { name: "order", label: "Sort order", type: "number" },
      { name: "published", label: "Published", type: "switch" },
    ],
  },

  redirects: {
    label: "301 Redirects",
    titleField: "from_path",
    fields: [
      { name: "from_path", label: "Old path (e.g. /case-study-information-technology/)", type: "text", required: true },
      { name: "to_path", label: "New path (e.g. /case-studies/slug)", type: "text", required: true },
      { name: "active", label: "Active", type: "switch" },
    ],
  },
};
